<div class="container">
    <div class="git">
        <img src="assets/img/maintenance.gif">
    </div>
    <!-- <h3>System is under maintenance</h3>
    <h5>We are preparing to servce you better</h5> -->
    <h3>{{errorMessage}}</h3>
</div>
<app-navigation-bar></app-navigation-bar>